import React, {useState, useRef, useEffect} from 'react';
import {
    Profile,
    Container,
    Divider,
    LeftSide,
    RightSide,
    DropDownContainer,
} from './styles';
import {ReactComponent as SearchIcon} from '../../assets/icons/search.svg';
import {ReactComponent as NotificationBell} from '../../assets/icons/notification_bell.svg';
import {ReactComponent as AvatarIcon} from '../../assets/images/avatar.svg';
import {ReactComponent as HamburgerMenu} from '../../assets/icons/hamburger_menu.svg';
import {fullNameForUser} from '../../utils';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {defaultTheme} from '../../styles/themes/default';
import {useNavigate} from "react-router-dom";
import {toggleSideBarMenu} from "../../app/sidebarMenu/actions";
import {selectAdminUser} from "../../app/adminUser/selectors";
import {adminUserLogout} from "../../app/adminUser/actions";

export const Topbar = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const dropdownRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const handleToggleSideBarMenu = () =>
        dispatch(toggleSideBarMenu());

    const handleToggleDropDown = () =>
        setIsDropdownOpen((prevState) => !prevState);

    const handleLogout = () => {
        document.cookie = "companio_work_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        dispatch(adminUserLogout())
        navigate('/')
    };

    const adminUser = useSelector(selectAdminUser);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <Container>
            <LeftSide>
                <button onClick={handleToggleSideBarMenu}>
                    <HamburgerMenu/>
                </button>
            </LeftSide>
            <RightSide>
                <SearchIcon className="search_icon"/>
                <NotificationBell/>
                <Divider/>
                <p>{fullNameForUser(adminUser)}</p>
                <Profile onClick={handleToggleDropDown} ref={dropdownRef}>
                    <AvatarIcon width={40} height={40}/>
                    {isDropdownOpen && (
                        <DropDownContainer>
                            <ul onClick={(e) => e.stopPropagation()}>
                                <li onClick={handleLogout} style={{color: defaultTheme.red}}>
                                    {t('logout')}
                                </li>
                            </ul>
                        </DropDownContainer>
                    )}
                </Profile>
            </RightSide>
        </Container>
    );
};
